import React from "react";
import { useTranslation } from "react-i18next";

import articlePublicationStatuses from "astrid-firestore/src/api/articles/constants/articlePublicationStatuses";

import Label from "../../../../ui/components/Label/Label";
import Popup from "../../../../ui/components/Popup/Popup";

import usePublicationStatuses from "../../../hooks/usePublicationStatuses";

export default function ArticleChannelLabel({ article, channel }) {
	const { t } = useTranslation();
	const publicationStatus =
		article?.channels?.[channel?.id]?.publicationStatus || articlePublicationStatuses.NOT_PUBLISHED;

	const publicationStatuses = usePublicationStatuses({ article, channel });

	const { text, color, date } = publicationStatuses[publicationStatus];

	const popupContent = date ? `${text} ${date}` : text;

	const active = article.channelIds.includes(channel.id);

	return (
		<Popup
			key={channel.id}
			content={active ? popupContent : t("disabled", "Disabled")}
			trigger={
				<Label color={color} style={{ opacity: !active && 0.4 }}>
					{channel.name}
				</Label>
			}
		/>
	);
}
